import { render, staticRenderFns } from "./Distributions.vue?vue&type=template&id=58262e9c&scoped=true"
import script from "./Distributions.vue?vue&type=script&lang=js"
export * from "./Distributions.vue?vue&type=script&lang=js"
import style0 from "./Distributions.vue?vue&type=style&index=0&id=58262e9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58262e9c",
  null
  
)

export default component.exports